export const getFundType = (fundData) => {
  if (fundData.securityExchange === 'PPRI' || fundData.exchange === 'PPRI')
    return 'fundsPrimary';

  if (fundData.securityType === 'FUND') return 'fundsManager';

  return '';
};
